import { db } from "./db";

const deleteItem = async (module, params) => {
    console.log(module, params);

    // Basisvalidatie van parameters
    if (!params || !module || !(module in db)) {
        console.error("Invalid parameters or module");
        return;
    }

    try {
        if (module !== "location_items" && module !== "location_item_components") {
            await db[module].where(params).delete();
        } else {
            await deleteChildren(module, params);
            await db[module].where(params).delete();
        }
        console.log("Deleted locally");
    } catch (error) {
        console.error("Error during deletion:", error);
    }
};

const deleteChildren = async (module, params) => {
    let children = [];

    try {
        if (module === "location_items") {
            children = await db["location_item_components"]
                .where({ location_item_uuid: params.uuid })
                .toArray();

            for (const child of children) {
                await deleteRelatedItems(child.uuid);
                await db["location_item_components"].where({ uuid: child.uuid }).delete();
            }
        } else if (module === "location_item_components") {
            await deleteRelatedItems(params.uuid);
        }
    } catch (error) {
        console.error("Error deleting children for", module, ":", error);
    }
};

const deleteRelatedItems = async (componentUuid) => {
    const relatedModules = [
        { module: "location_systems", key: "location_systemable_uuid" },
        { module: "documents", key: "documentable_uuid" },
        { module: "actions", key: "actionable_uuid" },
        { module: "measurements", key: "location_item_component_uuid" },
        { module: "observations", key: "location_item_component_uuid" },
    ];

    for (const relatedModule of relatedModules) {
        await db[relatedModule.module].where({ [relatedModule.key]: componentUuid }).delete();
        console.log(
            "Deleted related items for component:",
            componentUuid,
            "in",
            relatedModule.module
        );
    }
};

export default deleteItem;
